export var ApiConstant;
(function (ApiConstant) {
    ApiConstant["apiVersion"] = "v1";
    ApiConstant["apiEndpoint"] = "_forms/v1/forms";
})(ApiConstant || (ApiConstant = {}));
